const LoginOne = () => import('Modules/session/views/LoginOne')
const RegisterOne = () => import('Modules/session/views/RegisterOne')
const ForgotPassword = () => import('Modules/session/views/ForgotPassword')
const ResetPassword = () => import('Modules/session/views/ResetPassword')
const AccesoOne = () => import('Modules/session/views/AccesoOne')

const rutas = [
  {
    path: '/sesion/login',
    name: 'login',
    component: LoginOne,
    meta: {
      title: 'message.login',
      breadcrumbb: null
    }
  },
  {
    path: '/sesion/registro',
    name: 'registro',
    component: RegisterOne,
    meta: {
      title: 'message.login',
      breadcrumbb: null
    }
  },
  {
    path: '/sesion/olvide-password',
    name: 'olvide-password',
    component: ForgotPassword,
    meta: {
      title: 'Olvide mi Password',
      breadcrumb: null
    }
  },
  {
    path: '/sesion/cambiar-password/:token/:email',
    name: 'cambiar-password',
    component: ResetPassword,
    meta: {
      title: 'Cambiar Password',
      breadcrumb: null
    }
  },
  {
    path: '/sesion/acceso',
    name: 'acceso',
    component: AccesoOne,
    meta: {
      title: 'Selecciona institución - práctica',
      breadcrumbb: null
    }
  }
]

export default rutas
